/* import * as actions from './inspection.actions';
import * as actionTypes from './inspection.actionTypes';
import * as constants from './inspection.constants';
import reducer from './inspection.reducer';
import * as selectors from './inspection.selectors';
 */

export { default as reducer } from  './inspection.reducer';


// WEBPACK FOOTER //
// ./src/modules/inspection/index.js